/**
 * Type-safe accessor for i18n keys that return objects/arrays.
 * Single escape hatch for dynamic keys + `returnObjects: true`.
 * Used inside content hooks, never in components directly.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tObj<T>(t: (...args: any[]) => any, key: string): T {
  return t(key, { returnObjects: true }) as T;
}

/**
 * Plain-string sibling of `tObj`: resolves one string key through an untyped
 * `t`, keeping the deeply-typed `t()` out of content hooks that would otherwise
 * trip `TS2589` (see CLAUDE.md).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tStr(t: (...args: any[]) => any, key: string): string {
  return t(key) as string;
}
